module.exports = __webpack_public_path__ + "media/packs/images/cost/sea-bb9eeb2d0b6bd549a56fb156fb1d77ab.svg";